"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("../internal/SvgIcon"));

var IconWarning = function IconWarning(_ref) {
  var className = _ref.className,
      isActive = _ref.isActive,
      htmlId = _ref.htmlId,
      other = (0, _objectWithoutProperties2["default"])(_ref, ["className", "isActive", "htmlId"]);
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    id: htmlId,
    className: "svgicon ".concat(className ? "".concat(className, " ") : "").concat(isActive === true ? "svgicon--active " : "", "icon-warning")
  }, other), /*#__PURE__*/_react["default"].createElement("path", {
    className: "IconWarning__exclamation",
    d: "M6.4,17.8c1.8-3.6,3.7-7.2,5.5-10.8l6.2,10.8H6.4z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.216,17.529 L12.882,5.654 C12.506,4.948 11.494,4.948 11.117,5.654 L4.784,17.529 C4.429,18.195 4.912,19 5.667,19 L18.334,19 C19.088,19 19.571,18.195 19.216,17.529 Z M12,17 C11.448,17 11,16.552 11,16 C11,15.448 11.448,15 12,15 C12.552,15 13,15.448 13,16 C13,16.552 12.552,17 12,17 Z M13,14 L11,14 L11,10 L13,10 L13,14 Z"
  }));
};

var _default = IconWarning;
exports["default"] = _default;